module.exports = __webpack_public_path__ + "static/ester-portratt-1467821b5aa6a79c89b50c425d06b0eb.png";